import isOnSite from '@signal/utils/env/onSite'
import { HTML_FONT_SIZE } from '../variables'

/**
 * we can't use rem sizing when on-site because rem sizing is based on the outer page <html> tag sizing, and we want
 * the CSS within our on-site app to be completely under our control, with no bleed from the parent page.  For the
 * most part the shadow DOM provides this, but rem sizing is a notable exception
 * @param {String} remString - the original rem string, e.g. '1.1rem'
 * @return {Function} - it returns a function to give the new sizing string to use, which will be the same as original
 *   if not on-site, and a pixel based sizing if we are on-site.  A function is returned so as to use the callback
 *   form of any styled handler, to ensure the on-site setting exists before we evaluate these
 */
export function cleanupRemWhenOnSite(remString: string): () => string {
  return () => {
    if (!isOnSite()) {
      return remString
    }
    const scalar = parseFloat(remString)
    return `${scalar * HTML_FONT_SIZE}px`
  }
}

export default cleanupRemWhenOnSite
